<div class="button-container" (click)="action()">
  {{ name }}
</div>
